import React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import { Link } from "react-router-dom";
import { Comments, Doc, Landvision } from "../../../common/js/icons";
import get from "lodash/get";
import capitalize from "lodash/capitalize";
import { booleanToYN, aggregateBrokers, toDollarAmount, toSqft } from "../utils/operations";
import config from "../../../config";
import "./Listings.css";
import ReactGA from "react-ga4";

const TableHeaderArea = styled("div")({
    paddingTop: "17px",
});

const PaperPadding = styled("div")({
    padding: "0 20px 20px 20px",
    border: "1px solid #f1f1f1",
    marginBottom: "15px",
});

const PaperHeading = styled("h3")({
    fontSize: "18px",
    margin: "0",
    borderColor: "#f1f1f1",
    "&:hover": {
        cursor: "pointer",
        textDecoration: "underline",
    },
});

const PaperHeading2 = styled("h3")({
    fontSize: "14px",
    margin: "0",
    borderColor: "#f1f1f1",
    fontWeight: 600,
});

const PaperSubHeading = styled("div")({
    fontSize: 12,
});

const Hr = styled("hr")({
    margin: "0 0px 20px -20px",
    borderTop: "1px solid #f1f1f1",
});

const DefTerm = styled("span")({
    fontSize: "13px",
    textTransform: "uppercase",
    color: "#9E9E9E",
    fontWeight: 600,
});

const DefData = styled("span")({
    fontSize: "14px",
    color: "#000",
});

const LightButton = styled(Button)({
    fontWeight: "400",
    marginLeft: "0px",
    marginRight: "0px",
});

const LightButtonIcon = styled("span")({
    paddingRight: "3px",
    paddingTop: "6px",
    marginRight: "3px",
});

// Container styles to replace Grid
const FlexContainer = styled("div")({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    flex: '1 1 0',
    margin: '-8px'
});

const FlexRow = styled("div")({
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
});

const FlexColumn = styled("div")({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
});

const ButtonContainer = styled("div")({
    display: "flex",
    flexWrap: "wrap",
    marginLeft: "auto",
    justifyContent: "flex-end",
});

const DataGrid = styled("div")({
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-evenly",
    width: "100%",
    flexWrap: "wrap",
});

const DataItem = styled("div")({
    flex: "1 0 0",
    margin: "4px 0",
});

const ImageContainer = styled("div")({
    width: "100px",
    height: "94px",
    marginTop: "20px",
    backgroundSize: "cover",
    backgroundPosition: "center",
});

const ListingDataPreview = (props) => {
    const {
        canClose,
        currentPath,
        handleCheckboxClick,
        history,
        listing,
        listingTab,
        navigateToRequestUpdate,
        openCloseDealDialog,
        selectedListings,
    } = props;

    const navigateToLandvision = () => {
        ReactGA.event("Navigate To Landvision", {
            property: get(listing, "property.propertyKey"),
        });
        window.open(`${config.LANDVISION_URL}?resource=property&key=${get(listing, "property.propertyKey")}`, "_blank");
    };

    const handleRequestUpdate = () => {
        navigateToRequestUpdate(currentPath);
        history.push(`/listing/${listing.listingKey}`);
    };

    return (
        <PaperPadding>
            <FlexContainer>
                <FlexRow>
                    {listingTab === "broker_open" ? (
                        <ImageContainer
                            className="propertySmallImageContainer"
                            style={{
                                backgroundImage: `url(${get(listing, "primaryPhotoUrl", null)})`,
                            }}
                        />
                    ) : (
                        ""
                    )}
                    <TableHeaderArea
                        style={{paddingTop: "17px", padding: "20px", display: "flex", flexDirection: "column" }}
                    >
                        <FlexColumn style={{ position: "relative" }}>
                            {listingTab === "all_km_listings" && (
                                <div className="listingCheckboxDiv">
                                    <Checkbox
                                        className={
                                            selectedListings[listing.listingKey] === true
                                                ? "listingCheckboxSelected"
                                                : "listingCheckbox"
                                        }
                                        checked={selectedListings[listing.listingKey] === true}
                                        value={selectedListings[listing.listingKey] === true}
                                        onChange={() => handleCheckboxClick(listing.listingKey)}
                                        color="primary"
                                    />
                                </div>
                            )}
                            <Link
                                to={`/listing/${listing.listingKey}`}
                                style={
                                    listing.expired
                                        ? { color: "red", textDecoration: "none" }
                                        : { color: "#000", textDecoration: "none" }
                                }
                            >
                                <PaperHeading style={listingTab === "all_km_listings" ? { marginLeft: "8px" } : {}}>
                                    {`${get(listing, "listingName", "")}`}
                                </PaperHeading>
                            </Link>
                            <PaperHeading2 style={listingTab === "all_km_listings" ? { marginLeft: "8px" } : {}}>
                                {`No. ${get(listing, "listingKey", "") === null ? "" : get(listing, "listingKey", "")}`}
                            </PaperHeading2>
                        </FlexColumn>
                        <FlexColumn>
                            <PaperSubHeading style={listingTab === "all_km_listings" ? { marginLeft: "8px" } : {}}>
                                {`${
                                    get(listing, "property.primaryAddress.address1") === null
                                        ? ""
                                        : get(listing, "property.primaryAddress.address1")
                                }${get(listing, "property.primaryAddress.city.city") ? ", " : ""}${
                                    get(listing, "property.primaryAddress.city.city") === null
                                        ? ""
                                        : get(listing, "property.primaryAddress.city.city")
                                }${get(listing, "property.primaryAddress.city.state.stateCode") ? ", " : ""}${
                                    get(listing, "property.primaryAddress.city.state.stateCode") === null
                                        ? ""
                                        : get(listing, "property.primaryAddress.city.state.stateCode")
                                }${
                                    get(listing, "property.primaryAddress.zipCode.zipCode", null) !== null ? " • " : ""
                                }${
                                    get(listing, "property.primaryAddress.zipCode.zipCode", null) === null
                                        ? ""
                                        : get(listing, "property.primaryAddress.zipCode.zipCode", null)
                                }`}
                            </PaperSubHeading>
                        </FlexColumn>
                    </TableHeaderArea>
                <ButtonContainer>
                    {listing.flyerUrl && (
                        <LightButton onClick={() => window.open(listing.flyerUrl, "_blank")} color="primary">
                            <span>
                                <Doc style={{ marginRight: "5px" }} fill="#2C99D2" />
                            </span>
                            Flyer
                        </LightButton>
                    )}
                    <LightButton onClick={handleRequestUpdate} color="primary">
                        <LightButtonIcon>
                            <Comments fill="#2C99D2" />
                        </LightButtonIcon>
                        Request Update
                    </LightButton>

                    <LightButton onClick={() => navigateToLandvision()} color="primary">
                        <span style={{ marginRight: "5px" }}>
                            <Landvision fill="#2C99D2" />
                        </span>
                        LandVision
                    </LightButton>

                    {listing.nonKmListingFlg !== true && canClose && (
                        <Button variant="contained" color="primary" onClick={() => openCloseDealDialog(listing)}>
                            Close Deal
                        </Button>
                    )}
                </ButtonContainer>
                </FlexRow>
            </FlexContainer>

            {listingTab === "broker_open" ? (
                <div></div>
            ) : (
                <React.Fragment>
                    <Hr />
                    <DataGrid>
                        <DataItem>
                            <DefTerm>Date Avail</DefTerm>
                        </DataItem>
                        <DataItem>
                            <DefData>{listing.dateAvailable}</DefData>
                        </DataItem>
                        <DataItem>
                            <DefTerm>SF Div</DefTerm>
                        </DataItem>
                        <DataItem>
                            <DefData>
                                {listing.listingType === "Sale" ? "N/A" : toSqft(get(listing, "sfDivisibleTo"))}
                            </DefData>
                        </DataItem>
                        <DataItem>
                            <DefTerm>{listing.listingType === "Sale" ? "List Price" : "Monthly Rate"}</DefTerm>
                        </DataItem>
                        <DataItem>
                            <DefData>
                                {listing.listingType === "Sale"
                                    ? `${toDollarAmount(get(listing, "listPrice", ""))}`
                                    : `${toDollarAmount(get(listing, "askingRentMax", ""))}`}
                            </DefData>
                        </DataItem>
                        <DataItem>
                            <DefTerm>{listing.listingType === "Sale" ? "Floors" : "Annual Rate"}</DefTerm>
                        </DataItem>
                        <DataItem>
                            <DefData>
                                {listing.listingType === "Sale"
                                    ? `${get(listing, "floor", "")}`
                                    : `${toDollarAmount(get(listing, "askingRentMax", "") * 12)}`}
                            </DefData>
                        </DataItem>
                        <DataItem>
                            <DefTerm>Broker</DefTerm>
                        </DataItem>
                        <DataItem>
                            <DefData>
                                {get(listing, "listingAgent", null) !== null
                                    ? get(listing, "listingAgent", null)
                                    : aggregateBrokers(get(listing, "listingBrokers", []), "brokerAgentKey.person")}
                            </DefData>
                        </DataItem>
                    </DataGrid>
                    <DataGrid>
                        <DataItem>
                            <DefTerm>Type</DefTerm>
                        </DataItem>
                        <DataItem>
                            <DefData>
                                {get(listing, "attributes.useType", null) !== null
                                    ? `${capitalize(get(listing, "attributes.useType"))} ${capitalize(
                                          listing.listingType
                                      )}`
                                    : capitalize(listing.listingType)}
                            </DefData>
                        </DataItem>
                        <DataItem>
                            <DefTerm>{listing.listingType === "Sale" ? "Sale SF" : "SF Avail"}</DefTerm>
                        </DataItem>
                        <DataItem>
                            <DefData>{toSqft(get(listing, "sfAvail"))}</DefData>
                        </DataItem>
                        <DataItem>
                            <DefTerm>NNN Rate</DefTerm>
                        </DataItem>
                        <DataItem>
                            <DefData>{toDollarAmount(get(listing, "monthlyCamNNN"))}</DefData>
                        </DataItem>
                        <DataItem>
                            <DefTerm>Sublet</DefTerm>
                        </DataItem>
                        <DataItem>
                            <DefData>{booleanToYN(listing.subleaseFlg)}</DefData>
                        </DataItem>
                        <DataItem>
                            <DefTerm>Company</DefTerm>
                        </DataItem>
                        <DataItem>
                            <DefData>
                                {get(listing, "listingCompany", null) !== null
                                    ? get(listing, "listingCompany", "")
                                    : get(listing, "listingBrokers[0].brokerAgentKey.person.company.displayName")}
                            </DefData>
                        </DataItem>
                    </DataGrid>
                </React.Fragment>
            )}
        </PaperPadding>
    );
};

export default ListingDataPreview;